module.exports = __webpack_public_path__ + "img/slide_2.5c45e356.png";